// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlesItemCommentInfo-module__container--sXIJO{margin-right:3px}.ArticlesItemCommentInfo-module__container--sXIJO:not(:last-child):after{content:"|";margin-left:3px;color:#7b7f83}.ArticlesItemCommentInfo-module__name--JMFrg{color:#373e44}.ArticlesItemCommentInfo-module__count--ylhFf{margin-left:2px;color:#7b7f83}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticlesItemCommentInfo-module__container--sXIJO`,
	"name": `ArticlesItemCommentInfo-module__name--JMFrg`,
	"count": `ArticlesItemCommentInfo-module__count--ylhFf`
};
export default ___CSS_LOADER_EXPORT___;
